import React from "react";

export default ({ children }) => (
  <div className="custom-text-container">{children}</div>
);
